import styled, { keyframes, css } from 'styled-components';

const slideInAnimation = (childrenHeight = 0) => keyframes`
    0% { max-height: 0; }
    99% { max-height: ${childrenHeight}px; }
    100% { max-height: unset; } // unset allows the element to remain responsive
`;

const slideOutAnimation = (childrenHeight = 0) => keyframes`
    0% { min-height: ${childrenHeight}px; }
    100% { min-height: 0; }
`;

const slideInAnimationCss = css`
    animation-name: ${(props) => slideInAnimation(props.$childrenHeight)};
`;

const slideOutAnimationCss = css`
    animation-name: ${(props) => slideOutAnimation(props.$childrenHeight)};
`;

const CollapseWrapper = styled.div`
    display: flex;
    flex-direction: column;
    animation-duration: 500ms;
    animation-timing-function: ease;
    overflow: hidden;

    ${(props) => (props.$isOpen ? slideInAnimationCss : slideOutAnimationCss)}
`;

export default CollapseWrapper;
